<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  addAction?: () => void;
}>();
</script>

<template>
  <button
    class="flex h-[20px] w-[44px] items-center justify-between rounded-4 bg-white px-[7px] shadow-s-hover duration-100 ease-out hover:bg-gray-250 hover:shadow-none active:bg-gray-300 dark:bg-gray-900 dark:hover:bg-gray-750 dark:active:bg-gray-850"
    @click="() => props.addAction && props.addAction()"
  >
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-gray-500">
      <path d="M5 1V9" stroke-linecap="square" />
      <path d="M1 5H9" stroke-linecap="square" />
    </svg>

    <span class="flex h-[14px] w-[1px] bg-gray-250 dark:bg-gray-850"></span>

    <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-gray-500">
      <path d="M1 1H9" stroke-linecap="square" />
    </svg>
  </button>
</template>
